export default __webpack_public_path__ + "static/media/Anchor.e41d54a1.svg";